import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { AttributesMixin, define, type } from "@type-r/models";
import { FilterModel } from "lqx-react/lib";

import * as React from 'react';
export interface MultiSelectChipsFilter extends AttributesMixin<typeof MultiSelectChipsFilter> {}
@define
export class MultiSelectChipsFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        options : [String],
        selected : type([String]).required,
        placeholder: type(String).null,
        isDone : type(Boolean).check(function(x) { return x && this.selected && this.selected.length; })
    }

    delete() {
        this.$.selected.set(undefined);
        this.$.isDone.set(false);
    }

    asLabel() {
        return this.selected.length > 1 ? `Selected ${this.selected.length}` : this.selected[0];
    }

    asTitle() {
        return this.selected.map(x => x).join();
    }
}

export const EnterMultiSelectChips = ({ onEnter, filterValue }: {onEnter: any, filterValue: MultiSelectChipsFilter}) => {

    return (
        <Autocomplete
            multiple
            id="tags-outlined"
            size="small"
            defaultValue={filterValue.$.selected.value as any}
            loading={false}
            options={filterValue.$.options.value}
            getOptionLabel={(option) => option as string}
            filterSelectedOptions
            style={{ width: "500px", margin: "4px 4px 4px 0", border: '1px solid #c4c4c4', borderRadius: "4px" }}
            onChange={(_, item: any) => {
                filterValue.$.selected.set(item);
                onEnter(filterValue.clone())
            }}
            renderInput={(params) => (
                <TextField
                    {...params} 
                    variant="outlined" 
                    color="secondary"
                    placeholder={filterValue.$.placeholder.value}
                    style={{border: 'none' }}
                    className={filterValue.selected.length ? "" : "error"} 
                    />
            )}
        />
    );
}